// extracted by mini-css-extract-plugin
export default {"date":"HospitalIncidents_date_YayqF","new-incident-message":"HospitalIncidents_new-incident-message_ofFMe","truncate-message":"HospitalIncidents_truncate-message_LzMMJ"};